import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoginComponent, RecoverPasswordComponent } from '@core/auth';
import { DoctorsComponent, FormDoctorComponent, ProfileComponent } from './doctors';
import { ActiveConsultationComponent, ConsultationsComponent, ViewConsultationComponent } from './consultations';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { FormVersionComponent } from './configurations/version/form-version/form-version.component';
import { PoliciesComponent } from './policies/policies.component';
import { FormBookComponent } from './configurations/library/form-book/form-book.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'recover-password', component: RecoverPasswordComponent },

    { path: '', component: ConsultationsComponent, canActivate: [AuthGuard] },
    { path: 'doctors', canActivate: [AuthGuard], children: [
        { path: '', component: DoctorsComponent },
        { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
        { path: 'new', component: FormDoctorComponent },
        { path: 'edit/:id', component: FormDoctorComponent },
    ]},

    { path: 'consultations', canActivate: [AuthGuard], children: [
        { path: '', component: ConsultationsComponent },
        { path: 'active/:id', component: ActiveConsultationComponent },
        { path: 'view/:id', component: ViewConsultationComponent },
    ]},

    { path: 'configurations', canActivate: [AuthGuard], children: [
        { path: '', component: ConfigurationsComponent },
        { path: 'new', component: FormVersionComponent },
        { path: 'edit/:id', component: FormVersionComponent },
    ]},

    { path: 'library', canActivate: [AuthGuard], children: [
        { path: 'new', component: FormBookComponent },
    ]},
    { path: 'privacy-policy', component: PoliciesComponent },


    { path: '**', redirectTo: 'login' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
